"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Pagination, Button } from "@alifd/next";
import { connect } from "dva";
import React from "react";
import { If } from "../../components/If";
import { ListTitle } from "../../components/ListTitle";
import Permission from "../../components/Permission";
import { Translation } from "../../components/Translation";
import { locale } from "../../utils/locale";
import TableList from "./components/List";
import TargetDialog from "./components/TargetDialog";
import "./index.less";
let TargetList = class extends React.Component {
  constructor(props) {
    super(props);
    this.getTargetList = async () => {
      const { page, pageSize, query } = this.state;
      this.props.dispatch({
        type: "target/listTargets",
        payload: {
          query,
          page,
          pageSize
        }
      });
    };
    this.getClusterList = async () => {
      this.props.dispatch({
        type: "clusters/getClusterList"
      });
    };
    this.updateTargetList = () => {
      this.setState(
        {
          query: "",
          page: 0,
          pageSize: 10
        },
        () => {
          this.getTargetList();
        }
      );
    };
    this.changeISEdit = (isEdit, record) => {
      this.setState({
        isEdit,
        visibleDelivery: true,
        targetItem: record
      });
    };
    this.onClose = () => {
      this.setState({ visibleDelivery: false, isEdit: false });
    };
    this.onOk = () => {
      this.getTargetList();
      this.setState({
        isEdit: false
      });
    };
    this.handleChange = (page) => {
      this.setState(
        {
          page
        },
        () => {
          this.getTargetList();
        }
      );
    };
    this.state = {
      query: "",
      page: 1,
      pageSize: 5,
      showAddTarget: false,
      editTargetName: "",
      visibleDelivery: false,
      isEdit: false
    };
  }
  componentDidMount() {
    this.getTargetList();
    this.getClusterList();
  }
  render() {
    const { clusterList, targets, total } = this.props;
    const { visibleDelivery, isEdit, targetItem } = this.state;
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      ListTitle,
      {
        title: "Targets",
        subTitle: "Define the targets that applications would deliver to",
        extButtons: [
          /* @__PURE__ */ React.createElement(Permission, { key: "new-target", request: { resource: "target:*", action: "create" }, project: "" }, /* @__PURE__ */ React.createElement(
            Button,
            {
              type: "primary",
              onClick: () => {
                this.setState({ visibleDelivery: true, targetItem: void 0 });
              }
            },
            /* @__PURE__ */ React.createElement(Translation, null, "New Target")
          ), ",")
        ]
      }
    ), /* @__PURE__ */ React.createElement(
      TableList,
      {
        list: targets,
        updateTargetList: this.updateTargetList,
        changeISEdit: (is, record) => {
          this.changeISEdit(is, record);
        }
      }
    ), /* @__PURE__ */ React.createElement(
      Pagination,
      {
        className: "delivery-target-pagination",
        total,
        locale: locale().Pagination,
        size: "medium",
        pageSize: this.state.pageSize,
        current: this.state.page,
        onChange: this.handleChange
      }
    ), /* @__PURE__ */ React.createElement(If, { condition: visibleDelivery }, /* @__PURE__ */ React.createElement(
      TargetDialog,
      {
        visible: visibleDelivery,
        clusterList: clusterList || [],
        isEdit,
        targetItem,
        onClose: this.onClose,
        onOK: this.onOk
      }
    )));
  }
};
TargetList = __decorateClass([
  connect((store) => {
    return { ...store.target, ...store.clusters, ...store.user };
  })
], TargetList);
export default TargetList;
